<template>
    <div class="h-auto text-gray-800">
      <form action="" class="p-6 h-auto" @submit.prevent="send">
        <div class="w-full flex justify-end text-orange-academy-300">
          <button @click.prevent="$emit('close')" >
            <close-icon />
          </button>
        </div>
        <div class="flex flex-row items-center">
          <div class="mr-4 uppercase w-16 text-orange-academy-200 text-xs">
            {{ $t('messageForm.from') }} </div>
          <div class="text-grey-500 capitalize bg-gray-200 shadow-inner px-3 h-7
            items-center flex rounded-sm w-auto">
            {{ fromUser.name }} </div>
        </div>
        <div class="flex flex-row mt-4 items-center">
          <div class="mr-4 uppercase w-16 text-orange-academy-200 text-xs">
            {{ $t('messageForm.to') }} </div>
          <div class="text-grey-500 capitalize px-3 bg-gray-200 rounded-sm h-7
            shadow-inner flex items-center"
            v-if="toUser.name"> {{ toUser.name }} </div>
          <input v-else
            type="text"
            class="outline-none px-3 bg-gray-200 rounded-sm h-7 shadow-inner w-full"
            v-model="toUserName" required>
        </div>
        <div class="flex flex-row mt-4 items-center">
          <div class="mr-6 uppercase w-16 text-orange-academy-200 text-xs">
            {{ $t('messageForm.subject') }} </div>
          <div class="w-full">
            <input
            type="text"
            class="outline-none px-3 bg-gray-200 rounded-sm h-7 shadow-inner w-full"
            v-model="subject"
            required>
          </div>

        </div>

        <div class="flex flex-row mt-4">
          <!-- <div class="uppercase">{{ $t('messageForm.message') }} </div> -->
        </div>
        <div class="flex flex-row mt-4">
          <textarea
            name=""
            id=""
            class="w-full outline-none p-3 bg-gray-200 shadow-inner rounded-sm"
            rows="5"
            v-model="message"
            placeholder="Write here the message!"
            required>
          </textarea>
        </div>
        <div class="flex justify-end">
          <button
          class="bg-orange-academy-300 px-4 py-2 m-4 rounded
            hover:bg-orange-academy-200">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4 svgColor"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M8.31 189.9l176-151.1c15.41-13.3 39.69-2.509 39.69 18.16v80.05C384.6 137.9 512 170.1 512 322.3c0 61.44-39.59 122.3-83.34 154.1c-13.66 9.938-33.09-2.531-28.06-18.62c45.34-145-21.5-183.5-176.6-185.8v87.92c0 20.7-24.31 31.45-39.69 18.16l-176-151.1C-2.753 216.6-2.784 199.4 8.31 189.9z"/></svg>
          </button>
        </div>
      </form>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  components: { CloseIcon },
  props: {
    fromUser: {},
    toUser: {},
    subj: String,
  },

  data() {
    return {
      toUserName: '',
      subject: '',
      message: '',
    };
  },

  mounted() {
    if (this.subj) this.subject = this.subj;
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  methods: {
    send() {
      const message = {
        from_user_id: this.fromUser.id,
        to_user_id: this.toUser.id,
        subject: this.subject,
        body: this.message,
      };
      axios.post('/api/messages', message).then(() => {
        this.createNotification('success', this.$t('messageForm.sent'));
        this.$emit('close');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .inner-shadow {
    --tw-shadow: inset 4px 3px 3px 4px rgba(0, 0, 0, 0.733);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0.74)), var(--tw-ring-shadow,
    0 0 rgba(0, 0, 0, 0.712)), var(--tw-shadow);
  }
  .svgColor {
    fill: white;
  }
</style>
